export enum ContextualItemType {
    list = 'list',
    subMenu = 'subMenu',
    hr = 'hr'
}
